import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import './CombinationsModal.scss';
import { RootState } from '../../../../configs/store';
import  formatOdds  from '../../../../utils/formatOdds';
import Icon from '../../../Icon/Icon';
import { Permutation } from 'src/interfaces/LottoState';

interface CombinationsProps {
  title: () => void,
  onClick: () => void
  permutations: number[][],
  stake?: number,
  permutations2?: Permutation[]
  odds: number,
  profit?: number,
  isQuickBet?: boolean,
  height?: number,
  isRacing?: boolean,
  isModal?: boolean
}

function CombinationsModal({
  onClick,
  title,
  permutations,
  stake,
  profit,
  permutations2,
  odds,
  isQuickBet = false,
  height=0,
  isRacing = false,
  isModal=true
} : CombinationsProps) {
  const { t } = useTranslation();
  const { selectedOddsType } = useSelector((state: RootState) => state.odds);

  const dispatch = useDispatch();

  const handlePermutionsClose = useCallback(() => {
    dispatch.betslip.changeReadBetPermutations({ showPermutations: false, permutations: null });
  }, []);

  const handleClose = () => {
    handlePermutionsClose();
    onClick();
  };

  const enterKey = (e: KeyboardEvent) => {
    if (e.key === 'Enter') handleClose();
  };

  useEffect(() => {
    document.body.classList.add('disable-scroll');
    document.addEventListener('keydown', enterKey);

    return () => {
      document.body.classList.remove('disable-scroll');
      document.removeEventListener('keydown', enterKey);
    };
  }, []);

  return (
    <>
      {
        !isQuickBet && <div className="combinations__expanded">
        </div>
      }
      <div
        style={ height > 0 ? { height: height } : { height: 'auto' } }
        className={
          classNames({
            'combinations__information': true,
            'combinations__information--quick-bet': isQuickBet,
            'combinations__information--no-modal': !isModal
          })
        }
      >
        <div className="combinations__expanded-title">
          { title }
          <Icon icon="close" className="combinations__close" onClick={ handleClose } />
        </div>
        <table className="combinations__table">
          <thead className="combinations__thead">
            <tr className="combinations__table-thead">
              <td>
                { t('numbers.selections') }
              </td>
              {
                !isRacing && (
                  <>
                    <td>
                      { t('numbers.stake') }
                    </td>
                    <td>
                      { t('numbers.odds') }
                    </td>
                    <td>
                      { !isMobile && !isQuickBet ? t('numbers.potentialReturn') : t('numbers.potReturn') }
                    </td>
                  </>
                )
              }
            </tr>
          </thead>
          <tbody
            className={
              classNames({
                'combinations__tbody' :true,
                'combinations__tbody--quick-bet': isQuickBet
              })
            }
            style={ height > 0 ? { maxHeight: height - 110 } : { height: 'unset' } }
          >
            {
              permutations2 &&
              _.map(permutations2, (permutation, index) => {
                return (
                  <tr key={ index } className="combinations__elements">
                    {
                      !(permutation['numbers'] && permutation['bonus']) && <td className="combinations__numbers">{
                        permutation['numbers'] ?
                          permutation['numbers'].join(',') : permutation['bonus'].join(',')
                      }</td>
                    }
                    {
                      (permutation['numbers'] && permutation['bonus']) && <td className="combinations__numbers">{
                        `${ permutation['numbers'].join(',') } + ${ permutation['bonus'].join(',') }`
                      }</td>
                    }
                    <td className="combinations__stakes">{
                      permutation.stake && permutation.stake > 0 ? (+(permutation.stake))?.toFixed(2) : '-'
                    }</td>
                    {
                      !isRacing &&
                      (<>
                        <td className="combinations__odds">{
                          !isNaN(+(permutation.odds)) && +(permutation.odds) > 0 ? formatOdds(permutation.odds, selectedOddsType) : '-'
                        } </td>
                        <td>{ profit ? (profit)?.toFixed(2) : '-' }</td>
                      </>
                      )
                    }
                  </tr>
                );

              }
              )
            }
            {
              !permutations2 &&
              _.map(permutations, (numbers, index) => {
                if (_.isArray(numbers)){
                  return (
                    <tr key={ index } className="combinations__elements">
                      <td className="combinations__numbers">{ [numbers].join(',') }</td>
                      <td className="combinations__stakes">{ stake ? (+stake)?.toFixed(2) : '' }</td>
                      {
                        !isRacing &&
                      (<>
                        <td className="combinations__odds">{  !isNaN(+odds) && +odds > 0 ? formatOdds(odds, selectedOddsType) : '-' }</td>
                        <td>{ profit ? (profit)?.toFixed(2) : '-' }</td>
                      </>
                      )
                      }
                    </tr>
                  );
                } else {
                  return (
                    <tr key={ index } className="combinations__elements">
                      <td className="combinations__numbers">{ [numbers['permutation']].join(',') }</td>
                      <td className="combinations__stakes">{ stake ? (+stake)?.toFixed(2) : '' }</td>
                      {
                        !isRacing &&
                      (<>
                        <td className="combinations__odds">{  !isNaN(+odds) ? formatOdds(odds, selectedOddsType) : '-' }</td>
                        <td>{ profit ? (profit)?.toFixed(2) : '-' }</td>
                      </>
                      )
                      }
                    </tr>
                  );
                }

              }
              )
            }
          </tbody>
        </table>
        <div className="combinations__legend">
          { !isRacing && t('numbers.notBonus') }
        </div>
      </div>
    </>
  );
}

export default CombinationsModal;
